import { css } from '@emotion/css';

import { Colors, FontSize, FontWeight, Spacing } from '../../styles/constants';

export const copyLinkClassName = css({
  display: 'block',
});

export const wrapperClassName = css({
  position: 'relative',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'stretch',
  width: '100%',
});

export const inputClassName = css({
  border: `1px solid ${Colors.Gray}`,
  borderRadius: '8px 0 0 8px',
  borderRight: '0',
  flex: '1 1 auto',
  height: 42,
  overflow: 'auto',
  padding: `${Spacing.SM}px ${Spacing.MD}px`,
  position: 'relative',
  width: '1%',
  color: Colors.Primary,
  fontFamily: '"Nunito", sans-serif',
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.SEMI_BOLD,
  whiteSpace: 'nowrap',
});

export const actionClassName = css({
  display: 'flex',
  marginLeft: '-1px',
});

export const copyButtonClassName = css({
  background: Colors.White,
  border: `1px solid ${Colors.Gray}`,
  borderRadius: `0 8px 8px 0`,
  padding: `0 ${Spacing.MD}px`,
  '&:hover': {
    background: '#FAFAFA',
  },
});

export const buttonSuccessClassName = css({
  cursor: 'default',
  '&:hover': {
    background: '#FAFAFA',
  },
});

export const iconClassName = css({
  color: Colors.Secondary,
  '& svg': {
    height: 14,
    width: 14,
  },
});

export const bannerClassName = css({
  color: Colors.Green,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.MEDIUM,
  marginTop: Spacing.SM,
});
